import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=e6b498c8&scoped=true&"
import script from "./Renderer.vue?vue&type=script&lang=js&"
export * from "./Renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b498c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6b498c8')) {
      api.createRecord('e6b498c8', component.options)
    } else {
      api.reload('e6b498c8', component.options)
    }
    module.hot.accept("./Renderer.vue?vue&type=template&id=e6b498c8&scoped=true&", function () {
      api.rerender('e6b498c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v1/renderer/Renderer.vue"
export default component.exports